import { Currency_Switcher_Admin_Page } from './classes/class.currency-switcher-admin-page';
import { ICS_Admin_Page_Settings } from './classes/interface.currency-switcher-admin-page-settings';

// Add a reference to the global parameters
declare global {
	var wc_aelia_cs_admin_params: ICS_Admin_Page_Settings;
}

(function ready(callback, args) {
  if(document.readyState != 'loading'){
		// If this function is called after the document has finished loading,
		// invoke the callback immediately
		callback(args);
	}
	else {
		// If the document is still loading, trigger the callback on the
		// "DOM loaded" event
		document.addEventListener('DOMContentLoaded', () => callback(args));
  }
})(Currency_Switcher_Admin_Page.init, wc_aelia_cs_admin_params);
